import { defineMessages } from 'react-intl';

export default defineMessages({
  minute: {
    id: 'event_interval.minute.title',
    defaultMessage: 'Minute'
  },
  hour: {
    id: 'event_interval.hour.title',
    defaultMessage: 'Hour'
  },
  day: {
    id: 'event_interval.day.title',
    defaultMessage: 'Day'
  },
  month: {
    id: 'event_interval.month.title',
    defaultMessage: 'Month'
  },
});
